// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3FJ5N","search_container":"App_search_container__3Ogrv"};